import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/password-reset/request", { email });
            setSent(true);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erreur de l'envoi");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen">
            <PublicHeader />
            <section className="pt-32 pb-24 px-6 sm:px-8">
                <div className="max-w-md mx-auto tk-card p-8 sm:p-10">
                    {sent ? (
                        <div className="text-center" data-testid="forgot-success">
                            <CheckCircle2 className="w-12 h-12 text-[#34C759] mx-auto mb-4" />
                            <h1 className="text-2xl font-semibold tracking-tight text-[#1D1D1F]">
                                Vérifiez votre boîte mail
                            </h1>
                            <p className="mt-3 text-sm text-[#86868B]">
                                Si un compte existe pour <strong>{email}</strong>, vous allez recevoir un email
                                avec un lien de réinitialisation. Vérifiez vos spams si nécessaire.
                            </p>
                            <Link to="/login" className="tk-btn tk-btn-secondary mt-6 inline-flex">
                                <ArrowLeft className="w-4 h-4" /> Retour à la connexion
                            </Link>
                        </div>
                    ) : (
                        <>
                            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#1D1D1F]">
                                Mot de passe oublié&nbsp;?
                            </h1>
                            <p className="mt-2 text-sm text-[#86868B]">
                                Saisissez votre email, nous vous envoyons un lien de réinitialisation.
                            </p>
                            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                                <div>
                                    <label className="text-xs font-bold uppercase tracking-wider text-[#86868B] mb-2 flex items-center gap-2">
                                        <Mail className="w-3.5 h-3.5" /> Email
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="vous@exemple.fr"
                                        className="tk-input"
                                        data-testid="forgot-email"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={busy}
                                    className="tk-btn tk-btn-primary w-full justify-center"
                                    data-testid="forgot-submit"
                                >
                                    {busy ? "Envoi en cours…" : "Envoyer le lien"}
                                </button>
                            </form>
                            <p className="mt-6 text-center text-sm text-[#86868B]">
                                <Link to="/login" className="text-[#007AFF] hover:underline">
                                    ← Retour à la connexion
                                </Link>
                            </p>
                        </>
                    )}
                </div>
            </section>
        </div>
    );
}
